import React from 'react';
import { Button, Center, Stack, Card, Group, Flex, Title, Box, Text } from '@mantine/core';
import { IconExternalLink, IconLink, IconPencil } from '@tabler/icons';
import { NavLink, useLoaderData } from 'react-router-dom';
import DataTable from '../../Components/DataTable';
import useUserData from '../../Hooks/use-user-data';
import { ClientLoaderResult } from '../../Loaders/ClientLoader';
import { createClientTableData } from '../Technology/shared';
import { hasDescription } from '../Technology';

const Client = () => {
  const { client, persons } = useLoaderData() as ClientLoaderResult;
  const { isAdministrator } = useUserData();

  return (
    <Center>
      <Card maw={960} w={'100%'} withBorder shadow="sm" p="xl" radius="md">
        <Stack spacing={'sm'}>
          <Flex direction={'column'}>
            <Flex align={'center'} columnGap={'xl'}>
              <Title order={1}>{client.name}</Title>
              {client.url && (
                <Button
                  component="a"
                  href={client.url}
                  target="_blank"
                  variant="outline"
                  rightIcon={<IconExternalLink size={14} />}
                >
                  Go to homepage
                </Button>
              )}
            </Flex>
            {client.salesforceNumber && (
              <Text color={'dimmed'} mt={'xs'}>{`Salesforce number: ${client.salesforceNumber}`}</Text>
            )}
          </Flex>
          <DataTable data={createClientTableData(client, persons)} />
          {hasDescription(client.description) && (
            <Box dangerouslySetInnerHTML={{ __html: client.description as string }} />
          )}
          {client.technologies && client.technologies.length > 0 && (
            <Box>
              <Title order={3} mb={'xs'}>
                Related technologies
              </Title>
              <Group spacing={'xs'}>
                {client.technologies.map((technology) => (
                  <NavLink to={`/technology/${encodeURIComponent(technology.name)}`}>
                    <Button
                      variant="outline"
                      key={technology.id}
                      color={'avensia-blue'}
                      size="xs"
                      rightIcon={<IconLink size={16} />}
                    >
                      {technology.name}
                    </Button>
                  </NavLink>
                ))}
              </Group>
            </Box>
          )}

          {isAdministrator && (
            <Flex justify={'flex-end'} align={'center'}>
              <Button component={NavLink} miw={160} to={'edit'} variant="filled" rightIcon={<IconPencil size={16} />}>
                Edit
              </Button>
            </Flex>
          )}
        </Stack>
      </Card>
    </Center>
  );
};

export default Client;
